import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputGroup as InputGroupCore } from '@mc/react-core';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { MFieldProps } from '../types';

export type StringProps = MFieldProps<
  React.ComponentProps<typeof InputGroupCore>
>;
export const String = React.forwardRef<HTMLInputElement, StringProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      onChange: customOnChange,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        required={required}
        disabled={disabled}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: //form: { setFieldValue },
          FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (e: React.ChangeEvent<HTMLInputElement>) => {
                let realVal: string | undefined = e.target.value;
                if (realVal === '') {
                  realVal = undefined;
                }
                onChange({ target: { name, value: realVal } });
                customOnChange && customOnChange(realVal as any);
              },
              [customOnChange, onChange, name]
            );
            return (
              <InputGroupCore
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                name={name}
                {...other}
                disabled={disabled}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
